import config from "console_config";

import { bufferEvent } from "./pendoBuffer";
import { AnalyticsEvent } from "./types";

const hasPendoConfig = (): boolean =>
  Boolean(config.ID_PENDO || config.ID_PENDO_AUTH);

export const trackEventPendo = (
  eventOrName: AnalyticsEvent | string,
  payload?: Record<string, any>
): void => {
  if (!hasPendoConfig()) return;

  const name = typeof eventOrName === "string" ? eventOrName : eventOrName.name;
  const eventPayload =
    typeof eventOrName === "string"
      ? (payload ?? {})
      : (eventOrName.payload ?? {});

  if (!window.pendo) {
    bufferEvent(name, eventPayload);
    return;
  }

  window.pendo.track(name, eventPayload);
};
